/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSelector } from 'reselect';

import { RootState } from '../../../../ts/state';

export const getById = (state: RootState, id: string) =>
  state.models.intents[id];
export const getIntents = (state: RootState) => state.models?.intents || {};
export const getIntentExamples = (state: RootState) =>
  state.intents?.examples?.examples ||
  state.intents?.examples?.counterExamples ||
  [];
export const getAllIds = (state: RootState) => state.intents.allIds;
export const getEditingInfo = (state: RootState) => state.intents.editing;
export const getProps = (state: RootState) => state.intents.props;
export const getConflicts = (state: RootState) =>
  state.intents.conflicts.map(id => getById(state, id));

export const getAll = createSelector(
  [getAllIds, getIntents],
  (allIds, intents) => allIds.map(id => intents[id])
);

export const areIntentsLoading = (state: RootState) =>
  state.intents?.props?.loading;

export const selectAllIntents = createSelector([getIntents], intents =>
  intents ? Object.values(intents) : []
);
